import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  indexMessageBySearchSelector,
  messagesSelector,
  searchValueSelector,
  setIndexMessageBySearch,
  setUidMessagesBySearch,
  uidMessagesBySearchSelector,
} from "@/domains/chat/slice";
import findMessageUids from "@/domains/chat/helpers/findMessageUids";
import useSearchEvent from "@/domains/chat/hooks/useSearchEvent";
import ChatSearch from "@/domains/chat/components/chat/ChatSearch";

type Props = {
  show: boolean;
};

export default function ChatSearchContainer({ show }: Props) {
  const dispatch = useAppDispatch();
  const searchValue = useAppSelector(searchValueSelector);
  const uidMessagesBySearch = useAppSelector(uidMessagesBySearchSelector);
  const indexMessageBySearch = useAppSelector(indexMessageBySearchSelector);
  const messages = useAppSelector(messagesSelector);
  const { downSearchIndex, onChange, onCloseSearch, onKeyDown, upSearchIndex, onBlur, onFocus } =
    useSearchEvent();

  useEffect(() => {
    const uids = findMessageUids(messages, searchValue);
    dispatch(setUidMessagesBySearch(uids));
    dispatch(setIndexMessageBySearch(-1));
  }, [searchValue, messages, dispatch]);

  return (
    <ChatSearch
      value={searchValue}
      onChange={onChange}
      show={show}
      currSearchIndex={indexMessageBySearch + 1}
      total={uidMessagesBySearch.length}
      upSearchIndex={upSearchIndex}
      downSearchIndex={downSearchIndex}
      onClose={onCloseSearch}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
}
